<nb-select fullWidth [selected]="lang" (selectedChange)="changeLanguage($event)">
  <nb-option value="fa">فارسی</nb-option>
  <nb-option value="en">انگلیسی</nb-option>
  <nb-option value="ar">عربی</nb-option>
</nb-select>
